/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import React from 'react'
import { Section, getState, hasSvc, getBrand, openWindow, fixURL, matIcon, iconLabel, } from '../twd'
import { useBondDetail } from './use-bond-detail'
import { sectionCss } from './style'

const state = getState('bond_detail.important_documents', {
    show: true
})

export default () => {
    const [showSection, setShowSection_] = React.useState(state.value.show)
    const setShowSection = React.useCallback((m) => {
        state.set({show:m})
        setShowSection_(m)
    }, [])

    const bond = useBondDetail()
    let docs = Documents.map(f => f(bond)).filter(Boolean)
    if (docs.length===0) return null

    return <React.Fragment>
    <div className="xs-hide vertical-offset-sm"></div>
    <div data-name='bond-detail-important-documents'
        className="container vertical-offset-sm"
        css={sectionCss}>

        <div className="row vertical-offset-sm"></div>

        <div className="row"><div className="col-xs-12">
            <Section
                title="Important documents"
                show={showSection}
                setShow={setShowSection}
                cls="small-header"
                arrowSize="large"
            >
            <div className="xs-show row vertical-offset-sm"></div>
            {
                docs.map( (d,i) => {
                    return <div key={i}className="row vertical-offset-sm"><div className="col-xs-12">
                        {d}
                        </div></div>
                })
            }
            </Section>
        </div></div>

        <div className="xs-show row vertical-offset-sm"></div>
    </div>

    </React.Fragment>
}

let Documents = [
    // factsheet
    ({issue, ask}) => {
        let f = hasSvc('FACT')
            && ['M','C'].indexOf(issue.type)>=0
            && issue.currencyCode === 'USD'
            && issue.floaterInd ==='N'
            && issue.linkedIndexInd ==='N'
        if (!f) return

        let sp = new URLSearchParams([
            ['p_id', ask.id || ''],
            ['p_type', issue.type || ''],
            ['p_cusip', issue.cusip || ''],
        ])

        let url = 'https://www.bonddesk.com/'
            + getBrand()
            + '/servlet/rtresult/factsheet.pdf?'
            + sp.toString()

        return <button
            type="button"
            className='link-button'
            onClick={() => openWindow(url, '_blank') }
            >{ iconLabel(matIcon('picture_as_pdf'), 'Factsheet') } </button>
    },

    // moody rating
    ({issue}) => {
        let f = hasSvc('MDBR')
            && ['M','C','A','P'].indexOf(issue.type)>=0
            && issue.moodyRating
            && ['-', 'Nr', 'Nr-A', 'NR', 'WR', 'Wr'].indexOf(issue.moodyRating)<0
        if (!f) return

        return <button
            type="button"
            className='link-button'
            onClick={() => openWindow(
                '/esb/moodysreport/getBondReport?cusip=' + issue.cusip,
                '_blank',
            )}
            >{ iconLabel(matIcon('picture_as_pdf'), "Moody's Bond Report") } </button>
    },

    // prospectus
    ({issue}) => {
        let { research } = issue
        let f = Array.isArray(research)
            && research.filter(r => r.type==='legal')[0]
        if (!f) return

        let url = 'https://www.bonddesk.com'
            + f.url.replace("BDResearch.showViewer('","").replace("');","")

        return <button
            type="button"
            className='link-button'
            onClick={() => openWindow(url, '_blank')}
            >{ iconLabel(matIcon('open_in_new'), 'Prospectus/Offering Document') }</button>
    },

    // emma
    ({issue}) => {
        let f = hasSvc('EMMA')
            && ['M'].indexOf(issue.type)>=0
            && issue.currencyCode==='USD'
        if (!f) return

        let url = fixURL('https://us.etrade.com/e/t/jumppage/viewjumppage?PageName=speedbump&comp=https%3A%2F%2Femma.msrb.org'
            + '%2FSecurityView%2FSecurityDetails.aspx%3Fcusip=' + issue.cusip)

        return <button
            type="button"
            className='link-button'
            onClick={() => openWindow(url, '_blank')}
            >{ iconLabel(matIcon('open_in_new'), 'Disclosure info/EMMA') }</button>
    },



]



// WEBPACK FOOTER //
// ./src/bond-detail/important-documents.js